module.exports = __webpack_public_path__ + "static/media/ph.3cc10f8e.svg";